import { FunctionComponent, useEffect, useState } from "react";

import RxPageLayout from "@/components/ui/display/RxPageLayout";
import LearningHeader from "@/components/marketing/learning/LearningHeader";
import MainCoursesContent from "@/components/marketing/learning/courses/MainCoursesContent";
import MainProgrammesContent from "@/components/marketing/learning/programmes/MainProgrammesContent.tsx";
import MarketingSubNav from "@/components/marketing/MarketingSubNav";
import { colours } from "@/utils";
import { Course } from "@/types/learning/Course";

type MainLearningContentProps = {
  slug: string;
  courses: Course[];
};

const navItems = [
  {
    href: "programmes",
    text: "Programmes",
  },
  {
    href: "courses",
    text: "Courses",
  },
];

const MainLearningContent: FunctionComponent<MainLearningContentProps> = (
  props
) => {
  const [slug, setSlug] = useState<string>(props.slug || "programmes");

  useEffect(() => {
    setSlug(props.slug);
  }, [props.slug]);

  const slugHandler = (slug: string) => {
    setSlug(slug);
  };

  const getContentHandler = (slug: string) => {
    if (slug === "programmes") return <MainProgrammesContent />;
    if (slug === "courses") return <MainCoursesContent {...props} />;

    return <MainProgrammesContent />;
  };

  return (
    <RxPageLayout>
      <LearningHeader />
      <MarketingSubNav
        navHandler={slugHandler}
        activeSection={slug}
        navItems={navItems}
        activeColour={colours.marketingYellow}
        pageBase="learning"
      />

      {getContentHandler(slug)}
    </RxPageLayout>
  );
};

export default MainLearningContent;
